import { useEffect } from "react";

export function useScrollParentToTop() {
  useEffect(() => {
    const message = { type: "scrollToTop" };
    window.parent.postMessage(message, "*"); // It's better to replace "*" with the exact parent origin for security
  });
}
